import React from 'react'
import Pagination from '@mui/material/Pagination';
import styled from '@emotion/styled'; // If using Emotion directly

import { Table, Card, Row, Col, FormControl } from 'react-bootstrap'
import { useTable, useSortBy, usePagination, useGlobalFilter } from 'react-table'

// props.pageSize
// props.pageCount
// props. data
const ScoreboardTableComponent = (props) => {
    const data = React.useMemo(() => props.data);

    const columns = React.useMemo(() => (
        [
            {
                Header: 'District Rank',
                accessor: 'districtRank'
            },
            {
                Header: 'Patrouille',
                accessor: 'totem'
            },
            {
                Header: 'Troupe',
                accessor: 'troupe'
            },
            {
                Header: 'Disctrict',
                accessor: 'district'
            },
            {
                Header: 'Score',
                accessor: 'score',
                
                
            }
        ]
    ), [])




    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        setGlobalFilter,
        state: { pageIndex, pageSize, globalFilter }
    } = useTable(
        {
            columns,
            data,
            initialState: {
                pageSize: props.pageSize,
                sortBy: [
                    {
                        id: 'rank',
                        desc: false
                    }
                ]
            }
        },
        useGlobalFilter, usePagination)

    let [pageNumber, setPageNumber] = React.useState(1);
    const handleChange = (event, value) => {
        setPageNumber(value)
        gotoPage(value - 1)
    }

    return (
        <>

            <Row className="my-2 "><Col xs={6} md={4}><FormControl placeholder={"Search"} value={globalFilter || ""} onChange={e => setGlobalFilter(e.target.value)} /></Col></Row>
            <Table className="mx-auto" striped bordered hover {...getTableProps()}>
                <thead>
                    {headerGroups.map(group => (
                        <tr {...group.getHeaderGroupProps()}>
                            {group.headers.map(column => (
                                <th {...column.getHeaderProps()}>
                                    {column.render("Header")}

                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {page.map((row, i) => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()}>
                                {row.cells.map((cell) => {
                                    return (
                                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                    );
                                })}

                            </tr>
                        )
                    })}
                </tbody>
            </Table>



            <Card.Footer> <Pagination page={pageNumber} count={pageCount} onChange={handleChange} color="primary" /></Card.Footer>


        </>
    )
}

export default ScoreboardTableComponent
